(() => {
 const root = document.querySelector('[data-ynd-catalog]');
 const form = root?.querySelector('[data-filter-form]');
 if (!form) return;
 const url = new URL(location.href);
 if (url.searchParams.has('preview_theme_id')) {
  const input = document.createElement('input'); input.type='hidden'; input.name='preview_theme_id'; input.value=url.searchParams.get('preview_theme_id'); form.append(input);
 }
 const panel=root.querySelector('[data-filter-dialog]');
 const opener=root.querySelector('[data-open-filters]');
 const anchor=root.querySelector('[data-filter-anchor]');
 const mobile=window.matchMedia('(max-width: 700px)');
 const placeFilters=()=>{
  if(!panel||typeof panel.showModal!=='function')return;
  if(mobile.matches){panel.insertBefore(form,panel.lastElementChild);opener.hidden=false;}
  else{if(panel.open)panel.close();anchor.after(form);opener.hidden=true;}
 };
 if(panel&&opener&&!root.hasAttribute('data-filter-inline')){
  opener.addEventListener('click',()=>{panel.showModal();document.dispatchEvent(new Event('ynd:overlay'));panel.querySelector('[data-close-filters]').focus()});
  panel.querySelectorAll('[data-close-filters]').forEach(button=>button.addEventListener('click',()=>panel.close()));
  panel.addEventListener('close',()=>{document.dispatchEvent(new Event('ynd:overlay'));opener.focus({preventScroll:true})});
  panel.addEventListener('click',event=>{if(event.target===panel){const b=panel.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)panel.close()}});
  panel.addEventListener('keydown', event => {
   if (!panel.open || event.key !== 'Tab' || event.ctrlKey || event.altKey || event.metaKey || event.defaultPrevented) return;
   const items = [...panel.querySelectorAll('a[href], button, input:not([type="hidden"]), select, textarea, summary, [tabindex]')].filter(element => {
    if (element.tabIndex < 0 || element.matches(':disabled') || element.getAttribute('aria-disabled') === 'true' || element.closest('[hidden], [inert], [aria-hidden="true"]') || !element.getClientRects().length) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse';
   });
   const active = document.activeElement, first = items[0], last = items[items.length - 1];
   if (!items.length || !items.includes(active) || (event.shiftKey ? active === first : active === last)) {
    event.preventDefault();
    (event.shiftKey ? last : first)?.focus({preventScroll:true});
   }
  });
  root.setAttribute('data-filter-ready', '');
  mobile.addEventListener('change',placeFilters);placeFilters();
 }
 if (form.dataset.mode !== 'complete') return;
 const grid = root.querySelector('[data-product-grid]');
 const cards = [...grid.querySelectorAll('[data-catalog-card]')].map((node,index) => {
  let options = {colors:[],sizes:[]};
  try { options=JSON.parse(node.querySelector('[data-product-options]').textContent); } catch {}
  return {node,index,title:node.dataset.title,type:node.dataset.type,colors:options.colors||[],sizes:options.sizes||[],available:node.dataset.available==='true'&&node.dataset.held!=='true',published:Number(node.dataset.published)||0};
 });
 const controls = [...form.querySelectorAll('[data-facet]')];
 controls.forEach(group => {
  const facet=group.dataset.facet;
  if(facet==='stock') return;
  const select=group.querySelector('select');
  const values=[...new Set(cards.flatMap(card=>facet==='type'?[card.type]:card[facet]).filter(Boolean))].sort((a,b)=>a.localeCompare(b,undefined,{numeric:true}));
  values.forEach(value=>{const option=document.createElement('option');option.value=value;option.textContent=value;select.append(option)});
  group.hidden=values.length===0;
 });
 form.querySelector('[data-client-filters]').hidden=false;
 const names=['ynd_type','ynd_color','ynd_size','ynd_stock'];
 const selectors=names.map(name=>form.elements.namedItem(name));
 const count=root.querySelector('[data-result-count]');
 const countTemplate=count.dataset.countLabel;
 const currentSort=form.elements.namedItem('sort_by');
 const initialSort=currentSort.value;
 const apply = (push=false) => {
  const selected=Object.fromEntries(names.map((name,i)=>[name,selectors[i].value]));
  const visible=cards.filter(card=>(!selected.ynd_type||card.type===selected.ynd_type)&&(!selected.ynd_color||card.colors.includes(selected.ynd_color))&&(!selected.ynd_size||card.sizes.includes(selected.ynd_size))&&(!selected.ynd_stock||(selected.ynd_stock==='available'?card.available:!card.available)));
  const sort=currentSort.value;
  const ordered=[...cards];
  if(sort==='title-ascending')ordered.sort((a,b)=>a.title.localeCompare(b.title));
  else if(sort==='title-descending')ordered.sort((a,b)=>b.title.localeCompare(a.title));
  else if(sort==='created-ascending')ordered.sort((a,b)=>a.published-b.published);
  else if(sort==='created-descending')ordered.sort((a,b)=>b.published-a.published);
  else ordered.sort((a,b)=>a.index-b.index);
  const shown=new Set(visible);
  ordered.forEach(card=>{card.node.hidden=!shown.has(card);grid.append(card.node)});
  count.textContent=(visible.length===1?count.dataset.countOne:countTemplate).replace('[count]',String(visible.length));
  root.querySelector('[data-filter-empty]').hidden=visible.length!==0||cards.length===0;
  if(push) grid.dispatchEvent(new Event('ynd:content-change', {bubbles:true}));
  if(push){const next=new URL(location.href);names.forEach(name=>{if(selected[name])next.searchParams.set(name,selected[name]);else next.searchParams.delete(name)});next.searchParams.set('sort_by',sort);next.searchParams.delete('page');history.pushState({},'',next);}
 };
 const fromUrl=()=>{const params=new URL(location.href).searchParams;selectors.forEach((select,i)=>{const value=params.get(names[i])||'';if(value&&![...select.options].some(o=>o.value===value)){const option=document.createElement('option');option.value=value;option.textContent=value;select.append(option)}select.value=value});currentSort.value=params.get('sort_by')||initialSort; if(!currentSort.value)currentSort.value=initialSort;apply(false)};
 form.addEventListener('submit',event=>{event.preventDefault();apply(true)});
 selectors.forEach(select=>select.addEventListener('change',()=>apply(true)));
 currentSort.addEventListener('change',()=>{
  if(['manual','best-selling','created-ascending','created-descending'].includes(currentSort.value)&&currentSort.value!==initialSort){const next=new URL(location.href);next.searchParams.set('sort_by',currentSort.value);location.assign(next);return;}
  apply(true);
 });
 root.querySelectorAll('[data-clear-filters]').forEach(button=>button.addEventListener('click',event=>{
  event.preventDefault();
  const fromEmpty = Boolean(button.closest('[data-filter-empty]'));
  selectors.forEach(select=>select.value='');apply(true);
  if (fromEmpty) {
   if (mobile.matches && opener && !opener.hidden) opener.focus({preventScroll:true});
   else { count.setAttribute('tabindex', '-1'); count.focus({preventScroll:true}); }
  }
 }));
 window.addEventListener('popstate',fromUrl);
 fromUrl();
})();
